import LazyLoad from 'vanilla-lazyload';

const Magazine = {

    activeFilters: [],

    // __________________________________________________________________________________________

    /**
     * Return bool if is mobile
     * @returns {Boolean}
     */
    init() {
        var that = this;

        $(document).ready(function () {
            that.$containerMagazine = document.querySelector('.container-magazine');

            if(that.$containerMagazine) {
                that.$filters = that.$containerMagazine.querySelectorAll('.magazine-filters li a');
                that.$items = that.$containerMagazine.querySelectorAll('.item');
                that.$ajaxPlaceholder = that.$containerMagazine.querySelector('.ajax-posts-placeholder');
                that.$pagination = document.querySelector('.pagination');

                that.initFilters();
            }
        });
    },

    // __________________________________________________________________________________________

    /**
     * Enable filters
     */
    initFilters() {
        var that = this;

        this.$filters.forEach(($filter) => {

            // boot
            that.detectFilters($filter);

            $filter.addEventListener('click', (e) => {
                e.preventDefault();

                $filter.classList.toggle('active');

                // change current filters
                that.detectFilters($filter);

                // empty results
                that.empty();

                that.refill(0);

                that.lazy();
            })
        });
    },

    // __________________________________________________________________________________________

    logElementEvent(eventName, element) {
        // console.log(Date.now(), eventName, element.getAttribute("data-src"));
    },

    callback_exit(element) {
        Magazine.logElementEvent("🚪 EXITED", element);
    },

    callback_loading(element) {
        Magazine.logElementEvent("⌚ LOADING", element);
    },

    callback_loaded(element) {
        Magazine.logElementEvent("👍 LOADED", element);
    },

    callback_error(element) {
        Magazine.logElementEvent("💀 ERROR", element);
        element.src = "https://via.placeholder.com/440x560/?text=Error+Placeholder";
    },

    callback_finish() {
        Magazine.logElementEvent("✔️ FINISHED", document.documentElement);
    },

    callback_cancel(element) {
        Magazine.logElementEvent("🔥 CANCEL", element);
    },

    executeLazyScript(element) {
        var that = this;

        var lazyFunctionName = element.getAttribute("data-lazy-function");
        var lazyOffset = element.getAttribute('data-offset');

        if(parseInt(lazyOffset) > 0) {
            setTimeout(function(){Magazine.refill(lazyOffset); element.innerHTML = ''; },1000);
        }

        // var lazyFunction = lazyFunctions[lazyFunctionName];
        // if (!lazyFunction) return;
        // lazyFunction(element);
    },

    lazy() {
        this.LL = new LazyLoad({
            unobserve_entered: true, // <- To avoid executing the script multiple times
            callback_enter: this.executeLazyScript, // Assigning the function defined above
            callback_exit: this.callback_exit,
            callback_cancel: this.callback_cancel,
            callback_loading: this.callback_loading,
            callback_loaded: this.callback_loaded,
            callback_error: this.callback_error,
            callback_finish: this.callback_finish
        });
    },

    // __________________________________________________________________________________________

    /**
     * Refill with new posts from empty
     */
    refill(offset) {
        var that = this;

        // pass categories
        var filters = [];
        for (var key in that.activeFilters) {
            if (that.activeFilters.hasOwnProperty(key)) {
                if (that.activeFilters[key]) {
                    filters.push(key);
                }
            }
        }

        $.ajax({
            type: 'POST',
            url: that.$containerMagazine.getAttribute('data-ajax'),
            dataType: "html", // add data type
            data: { action: 'get_ajax_posts', cats: filters, offset: offset },
            success: function (response) {
                that.$ajaxPlaceholder.innerHTML += response;
                
                // update lazy load instance
                // wait new lazy
                setTimeout(function() {that.LL.update()},1000);
                
            }
        });
    },

    // __________________________________________________________________________________________

    /**
     * Detect if the filter is enabled or not
     * @param {*} $filter 
     */
    detectFilters($filter) {
        var that = this;

        var chunks = $filter.href.split("/");
        var notEmptyChunks = chunks.filter(chunk => chunk != "");
        var name = notEmptyChunks.pop();

        // set as filer current .active class
        if ($filter.classList.contains('active')) {
            that.activeFilters[name] = true;
        } else {
            that.activeFilters[name] = false;
        }
    },

    // __________________________________________________________________________________________

    /**
     * Svuota tutto
     */
    empty() {

        var that = this;

        // original results
        that.$items.forEach(($item) => {
            $item.remove();
        });

        // ajax placeholder
        that.$ajaxPlaceholder.innerHTML = '';

        that.$pagination.remove();
    }

    // __________________________________________________________________________________________

};

export default Magazine;